import { Show } from '@/assets/icons'

type ReadOnlyMatterArtifactBannerProps = {
  ownerDisplayName: string | null
}

function getOwnerBannerText(ownerDisplayName: string | null): string {
  const trimmedName = ownerDisplayName?.trim()
  if (!trimmedName) return "Viewing another collaborator's draft"
  return `Viewing ${trimmedName}'s draft`
}

/** View-only affordance shown above a matter artifact the current user does not own. */
export default function ReadOnlyMatterArtifactBanner({ ownerDisplayName }: ReadOnlyMatterArtifactBannerProps) {
  return (
    <div className="flex h-9 shrink-0 items-center border-b border-true-gray-200 bg-true-gray-100 px-2 py-1.5">
      <div className="flex min-w-0 items-center gap-1 rounded px-2 py-0.5">
        <Show className="h-3.5 w-3.5 shrink-0 text-brand-neutral-950" aria-hidden="true" />
        <p className="min-w-0 truncate text-xs font-medium leading-4 text-brand-neutral-950">{getOwnerBannerText(ownerDisplayName)}</p>
      </div>
    </div>
  )
}
